import JSEncrypt from "jsencrypt";
import { publicKey } from "./public-mini.js";
import { privateKey } from "./private.js";
/* 注:采用标准模式:公钥加密,私钥解密 (使用 jsencrypt, PKCS1 v1.5) */

/**
 * rsa加密
 * @param {*} data 需要加密的内容,String格式
 * @returns
 */
export function rsaEncrypt(data) {
  return new Promise((resolve, reject) => {
    const enc = new JSEncrypt();
    enc.setPublicKey(publicKey);
    const cipherText = enc.encrypt(data);
    if (cipherText === false) {
      reject(new Error("RSA encrypt failed"));
    } else {
      resolve(cipherText);
    }
  }).catch((err) => {
    console.log(err);
    return "权限不足,请联系管理员";
  });
}

/* rsa解密 */
export function rsaDecrypt(data) {
  return new Promise((resolve, reject) => {
    const dec = new JSEncrypt();
    dec.setPrivateKey(privateKey);
    const rawText = dec.decrypt(data);
    if (rawText === false) {
      reject(new Error("RSA decrypt failed"));
    } else {
      resolve(rawText);
    }
  }).catch((err) => {
    console.log("err==============", err);
    return "权限不足,请联系平台客服";
  });
}
